import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import * as text from '@/components/general/TextStyles';

interface IStyledButton {
  fs?: number;
  hideOnSmallScreen?: boolean;
  disabled?: boolean;
  $inverted?: boolean;
  nothover?: boolean;
}

const ButtonStyle = css<IStyledButton>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid ${(props) => props.theme.colors.black};
  border-radius: 100px;
  background-color: ${(props) =>
    props.$inverted ? props.theme.colors.black : props.theme.colors.white};
  color: ${(props) =>
    props.$inverted ? props.theme.colors.white : props.theme.colors.black};
  transition: ${(props) => props.theme.transition.primary};
  overflow: hidden;
  font-size: 18px;
  line-height: 21px;
  ${(props: IStyledButton) => {
    if (props.fs === 16) {
      return `${text.FS16}`;
    }
  }}
  ${(props: IStyledButton) => {
    if (props.fs === 14) {
      return `${text.FS14}`;
    }
  }}
  pointer-events: ${(props: IStyledButton) =>
    props.disabled ? 'none' : 'auto'};

  &:hover {
    background-color: ${(props) =>
      props.$inverted ? props.theme.colors.white : props.theme.colors.black};
    color: ${(props) =>
      props.$inverted ? props.theme.colors.black : props.theme.colors.white};
    transform: ${(props: IStyledButton) =>
      props.nothover ? 'none' : 'translate(0, -5px)'};

    & path {
      stroke: ${(props) =>
        props.$inverted ? props.theme.colors.black : props.theme.colors.white};
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    display: ${(props: IStyledButton) =>
      props.hideOnSmallScreen ? 'none' : 'inline'};
    margin: 0;
  }
`;

export const StyledButton = styled.button<IStyledButton>`
  ${ButtonStyle}
`;

const LinkStyle = css`
  font-size: inherit;
  line-height: inherit;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:visited {
    color: inherit;
  }
`;

export const StyledLink = styled(Link)`
  ${LinkStyle}
`;

export const StyledLinkOut = styled.a`
  ${LinkStyle}
`;
